import { render } from "./index.vue?vue&type=template&id=67f61dfa&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=67f61dfa&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-67f61dfa"

export default script